import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  SxProps,
  RadioGroupProps,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Option, BooleanOption } from 'store/CreatePropertyAdSlice/types'
import Label, { LabelProps } from './Label'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  useController,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../'

type OptionsType = BooleanOption | Option

interface ConnectedRadioProps extends RadioGroupProps {
  options?: OptionsType[]
  onChange?: (arg: any) => void
  title?: string
  titleProps?: LabelProps
  getterValue?: string
  translateTitle?: boolean
  sxProps?: SxProps
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues?: UseFormGetValues<FormValues>
  resetField?: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name: Path<FormValues>
  rules?: RegisterOptions
}

const ConnectedRadioField = (props: ConnectedRadioProps) => {
  const {
    options = [],
    onChange,
    title,
    titleProps,
    getterValue,
    translateTitle = false,
    sxProps,
    control,
    trigger,
    getValues,
    resetField,
    setValue,
    name,
    rules,
    ...rest
  } = props
  const { t } = useTranslation()

  const {
    field,
    fieldState: { error },
  } = useController<FormValues>({
    name,
    control,
    rules: rules,
    defaultValue: '',
    shouldUnregister: true,
  })

  return (
    <Stack spacing={2}>
      <FormControl variant="standard" error={!!error}>
        <FormLabel>
          {title ? (
            <Label
              label={title}
              translateLabel={translateTitle}
              required={true}
              {...titleProps}
            />
          ) : null}
        </FormLabel>
        <RadioGroup
          {...field}
          row
          sx={{
            ...sxProps,
          }}
          {...rest}
        >
          {options.map((item) => (
            <FormControlLabel
              key={item.label}
              value={item.value}
              control={<Radio />}
              label={t(item.label) as unknown as string}
            />
          ))}
        </RadioGroup>
        {error ? <FormHelperText>{error?.message}</FormHelperText> : null}
      </FormControl>
    </Stack>
  )
}

export default ConnectedRadioField
